// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cdafd604","239":"9448c247","667":"fa450859"}[chunkId] + ".chunk.js";
};